const defaultState = {
  user: {},
  error: null,
  fetching: false,
  fetched: false
};

const updateUserReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_USER_FETCH_PENDING': {
      return {
        ...state, fetching: true, error: null
      };
    }
    case 'UPDATE_USER_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, error: null, fetched: true, user: action.payload
      };
    }
    case 'UPDATE_USER_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        user: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default updateUserReducer;


// WEBPACK FOOTER //
// ./src/reducers/updateUser.js